export interface RegisterFormModel {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  confirmPassword: string;
}

export interface RegisterFormFieldConfig {
  key: keyof RegisterFormModel;
  label: string;
  type: 'text' | 'email' | 'password';
  required: boolean;
  validators?: {
    email?: boolean;
    minlength?: number;
    maxlength?: number;
  };
}

export const REGISTER_FORM_INITIAL_MODEL: RegisterFormModel = {
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  confirmPassword: '',
};

export const REGISTER_FORM_FIELDS_CONFIG: RegisterFormFieldConfig[] = [
  {
    key: 'firstName',
    label: 'Nome',
    type: 'text',
    required: true,
    validators: { minlength: 2, maxlength: 60 },
  },
  {
    key: 'lastName',
    label: 'Cognome',
    type: 'text',
    required: true,
    validators: { minlength: 2, maxlength: 60 },
  },
  {
    key: 'email',
    label: 'Email',
    type: 'email',
    required: true,
    validators: { email: true, maxlength: 100 },
  },
  {
    key: 'password',
    label: 'Password',
    type: 'password',
    required: true,
    validators: { minlength: 8, maxlength: 64 },
  },
  {
    key: 'confirmPassword',
    label: 'Conferma password',
    type: 'password',
    required: true,
    validators: { minlength: 8, maxlength: 64 },
  },
];
